import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ContractOverviewPayrollPolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import hasFeature from 'modules/core/lib/hasFeature'

import ContractData from 'modules/contracts/components/ContractDetails/Section/ContractData'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import GrossSalary from './GrossSalary'
import PayrollPolicy from './PayrollPolicy'

interface Props {
  contractVersion: ContractVersion
  contractPayrollPolicy: ContractOverviewPayrollPolicyFragment | undefined | null
  employee: Employee
  isNewAdditionalCompensationsSupportEnabled?: boolean
}

const Salary = ({
  contractVersion,
  contractPayrollPolicy,
  employee,
  isNewAdditionalCompensationsSupportEnabled,
}: Props) => {
  const canSeeGrossSalary = policyAuthorizations.for('contracts.see_gross_salary', employee)
  const canSeePayrollPolicy = policyAuthorizations.for('contracts.see_payroll_policy', employee)
  const canEdit = policyAuthorizations.for('contracts.edit', employee)

  const hasPayrollPolicyContent = !!contractPayrollPolicy || canEdit
  const showPayrollPolicy =
    canSeePayrollPolicy && hasFeature('payroll_bundle') && hasPayrollPolicyContent
  const showGrossSalary =
    canSeeGrossSalary && (!!contractVersion.attributes.salary_amount || canEdit)

  return (
    <ContractData>
      <Box gap="s24">
        {showGrossSalary && <GrossSalary contractVersion={contractVersion} employee={employee} />}
        {!isNewAdditionalCompensationsSupportEnabled && showPayrollPolicy && (
          <PayrollPolicy canEdit={canEdit} contractPayrollPolicy={contractPayrollPolicy} />
        )}
      </Box>
    </ContractData>
  )
}

export default observer(Salary)
